import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";

// 🔧 ÉTAPE 1 : Vérification des variables d'environnement
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// 🔧 ÉTAPE 2 : Vérification CORRIGÉE de la validité de la config
const isConfigValid = !!(firebaseConfig.apiKey && 
                         firebaseConfig.authDomain && 
                         firebaseConfig.projectId &&
                         firebaseConfig.appId);

if (!isConfigValid) {
  console.error('🚨 FIREBASE CONFIG MANQUANTE!');
  console.log('Variables manquantes:', {
    apiKey: !!firebaseConfig.apiKey,
    authDomain: !!firebaseConfig.authDomain,
    projectId: !!firebaseConfig.projectId,
    appId: !!firebaseConfig.appId
  });
} else {
  console.log('✅ Configuration Firebase valide');
}

// 🔧 ÉTAPE 3 : Configuration pour Service Worker (VRAIES VALEURS FIREBASE)
export const firebaseConfigForSW = {
  apiKey: "AIzaSyAYSP45K7eDTsOrc1JZFZvVCJzTURBRJiQ",
  authDomain: "energesync-solution.firebaseapp.com",
  projectId: "energesync-solution",
  storageBucket: "energesync-solution.firebasestorage.app", // ✅ VRAIE VALEUR
  messagingSenderId: "127905387187", // ✅ VRAIE VALEUR (sans le 1)
  appId: "1:127905387187:web:8f1038b216c02caccdd6c6", // ✅ VRAIE VALEUR
  measurementId: "G-FF2Z9LRXPW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// 🔧 ÉTAPE 4 : Analytics conditionnel (seulement si config valide)
let analytics = null;
if (isConfigValid && firebaseConfig.measurementId) {
  try {
    analytics = getAnalytics(app);
    console.log('✅ Analytics initialisé');
  } catch (error) {
    console.warn('⚠️ Analytics non disponible:', error.message);
  }
}
export { analytics };

// 🔧 ÉTAPE 5 : Messaging amélioré
let messaging = null;
if (typeof window !== 'undefined' && 'serviceWorker' in navigator && isConfigValid) {
  try {
    messaging = getMessaging(app);
    console.log('✅ Firebase Messaging initialisé');
    
    // 🔧 FONCTION pour envoyer config au Service Worker
    const sendConfigToSW = () => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'FIREBASE_CONFIG',
          config: firebaseConfigForSW
        });
        console.log('📤 Configuration envoyée au Service Worker');
      }
    };
    
    // Envoyer immédiatement si SW déjà actif
    sendConfigToSW();
    
    // Écouter les changements de contrôleur
    navigator.serviceWorker.addEventListener('controllerchange', sendConfigToSW);
    
    // 🔧 NOUVEAU : Écouter quand le SW devient ready
    navigator.serviceWorker.ready.then(() => {
      setTimeout(sendConfigToSW, 100); // Petit délai pour s'assurer que le SW est prêt
    });
    
  } catch (error) {
    console.error("❌ FCM initialization error:", error);
  }
}
export const fcm = messaging;

// 🔧 ÉTAPE 6 : Debug info amélioré
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Firebase Config Debug:', {
    isConfigValid: isConfigValid, // ✅ Maintenant un vrai booléen
    hasMessaging: !!messaging,
    hasAnalytics: !!analytics,
    projectId: firebaseConfig.projectId,
    appIdFormat: firebaseConfig.appId, // Pour vérifier le format
    hasServiceWorker: 'serviceWorker' in navigator
  });
}

export default app;